import React, { useEffect } from 'react';
import { Switch, Route, Redirect, useLocation } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import Start from '../../components/signup/start';
import Setup from './setup';
import SelectConnectorContainer from './select-connector';
import Success from '../../components/signup/success';
import Tier from '../../components/buy-flow/tier-selector';
import PageNotFound from '../../components/page-not-found';
import { isFormIncomplete } from '../../lib/shared-signup';
import { selectState } from '../../selectors';
import { toggleIsSoho } from '../../store/avatax-signup';
import { getConnectors, getMarketingDataFromUrl, getSignupPartnerParams } from '../../lib/side-effects';
import { setActiveFlow } from '../../store/system';
import { checkIsAuthenticated } from '../../lib/helpers';
import CybersourcePaymentPage from '../../components/cybersource-payment';
const Signup = () => {
    const dispatch = useDispatch();
    const location = useLocation();
    const { sharedSignup, avataxSignup: { partnerSignup } } = useSelector(selectState);
    const incompleteSignupForm = isFormIncomplete(sharedSignup);
    const redirectToShift4Shop = /3dcart/i.test(location.search);
    useEffect(() => {
        if (checkIsAuthenticated())
            return;
        dispatch(getConnectors());
        dispatch(setActiveFlow('avatax-direct-buy'));
    }, []);
    useEffect(() => {
        if (checkIsAuthenticated())
            return;
        dispatch(getSignupPartnerParams(location.search));
        dispatch(getMarketingDataFromUrl());
        dispatch(toggleIsSoho(location.search));
    }, [location.search]);
    useEffect(() => {
        if (checkIsAuthenticated())
            return;
        dispatch(getMarketingDataFromUrl());
    }, [partnerSignup === null || partnerSignup === void 0 ? void 0 : partnerSignup.code]);
    if (redirectToShift4Shop) {
        const searchParams = new URLSearchParams(location.search);
        searchParams.set('partner', 'shift4shop');
        return React.createElement(Redirect, { to: { pathname: location.pathname, search: searchParams.toString() } });
    }
    return (React.createElement(Switch, null,
        React.createElement(Route, { exact: true, path: '/buy', component: Start }),
        React.createElement(Route, { path: '/buy/company', component: Setup }),
        React.createElement(Route, { path: '/buy/connector' }, incompleteSignupForm
            ? React.createElement(Redirect, { to: { pathname: '/buy', search: location.search } })
            : React.createElement(Route, { path: '/buy/connector', component: SelectConnectorContainer })),
        React.createElement(Route, { path: '/buy/success', component: Success }),
        React.createElement(Route, { exact: true, path: '/buy/buy', component: Tier }),
        React.createElement(Route, { exact: true, path: '/buy/buy/payment' },
            React.createElement(CybersourcePaymentPage, { paymentView: 'default' })),
        React.createElement(Route, { component: PageNotFound })));
};
export default Signup;
